import { useContext } from 'react'

import {
  Box,
  Button,
  DoughnutChart,
  Icon,
  Text,
  ThemeColors,
  adjustColorBrightness,
  getThemeColor,
} from '@fairfashion/design-system'
import { useTheme } from 'styled-components'

import { timeStampToDate } from '../../../../utilities/masks/dates'
import { ProviderContext } from '../../provider.context'

import * as Styles from './provider-risks-card.styles'
export const ProviderRisksCard = () => {
  const theme = useTheme()
  const { companyTraceabilityStatistics, actions } = useContext(ProviderContext)
  const hasRisk =
    companyTraceabilityStatistics &&
    companyTraceabilityStatistics?.socialEnvironmentalRiskQuantitySum.value > 0

  return hasRisk ? (
    <Styles.Container
      borderRadius={theme.border_radius.table}
      boxShadow={theme.box_shadow.card}
      backgroundColor={theme.colors.custom.white}
      padding={3}
      gap={2}
      direction="column"
      width="100%"
    >
      <Box width="100%" justifyContent="space-between" alignItems="center">
        <Box gap={1} alignItems="center">
          <Icon name="alert" color="grey_2" size={20} />
          <Text size="small" fontWeight={500} color="grey_2">
            Riscos Socioambientais
          </Text>
        </Box>
        <a href="#tabs">
          <Button
            variant="outlined"
            fontSize="small"
            padding={`${theme.spacing['1']} ${theme.spacing['2']}`}
            onClick={() => actions.setActiveTab('Riscos socioambientais')}
          >
            Ver detalhes
          </Button>
        </a>
      </Box>
      <Box
        width="100%"
        justifyContent="space-between"
        alignItems="stretch"
        flexWrap="wrap"
        gap={2}
      >
        <Box alignItems="center" gap={2} flexWrap="wrap">
          <DoughnutChart
            size={120}
            parts={[
              {
                value:
                  companyTraceabilityStatistics
                    ?.socialEnvironmentalRiskQuantitySlavery.value ?? 0,
                color: `${adjustColorBrightness(getThemeColor('warning', theme), 0.15)}`,
              },
              {
                value:
                  companyTraceabilityStatistics
                    ?.socialEnvironmentalRiskQuantityEmbargo.value ?? 0,
                color: getThemeColor('warning', theme),
              },
              {
                value:
                  companyTraceabilityStatistics
                    ?.socialEnvironmentalRiskQuantityRegistrationStatus.value ??
                  0,
                color: adjustColorBrightness(
                  getThemeColor('warning', theme),
                  -0.15,
                ),
              },
            ]}
            totalValue={
              companyTraceabilityStatistics?.socialEnvironmentalRiskQuantitySum
                .value ?? 0
            }
          />
          <Box direction="column" gap={2}>
            <Box alignItems="center" gap={1}>
              <Styles.LegendColor
                backgroundColor={
                  `${adjustColorBrightness(getThemeColor('warning', theme), 0.15)}` as ThemeColors
                }
              />
              <Text>
                <strong>
                  {
                    companyTraceabilityStatistics
                      ?.socialEnvironmentalRiskQuantitySlavery.value
                  }
                </strong>
              </Text>
              <Text>
                {
                  companyTraceabilityStatistics
                    ?.socialEnvironmentalRiskQuantitySlavery.title
                }
              </Text>
            </Box>
            <Box alignItems="center" gap={1}>
              <Styles.LegendColor
                backgroundColor={getThemeColor('warning', theme)}
              />
              <Text>
                <strong>
                  {companyTraceabilityStatistics
                    ?.socialEnvironmentalRiskQuantityEmbargo.value ?? 0}
                </strong>
              </Text>
              <Text>
                {
                  companyTraceabilityStatistics
                    ?.socialEnvironmentalRiskQuantityEmbargo.title
                }
              </Text>
            </Box>
            <Box alignItems="center" gap={1}>
              <Styles.LegendColor
                backgroundColor={
                  `${adjustColorBrightness(getThemeColor('warning', theme), -0.15)}` as ThemeColors
                }
              />
              <Text>
                <strong>
                  {companyTraceabilityStatistics
                    ?.socialEnvironmentalRiskQuantityRegistrationStatus.value ??
                    0}
                </strong>
              </Text>
              <Text>
                {
                  companyTraceabilityStatistics
                    ?.socialEnvironmentalRiskQuantityRegistrationStatus.title
                }
              </Text>
            </Box>
          </Box>
        </Box>
        <Box flex={1} alignItems="flex-end" justifyContent="flex-end" gap={1}>
          <Text size="small" color="grey_3">
            {
              companyTraceabilityStatistics
                ?.lastSocialEnvironmentalRiskApiRequest.title
            }
          </Text>
          <Text size="small" color="grey_3">
            {companyTraceabilityStatistics &&
              timeStampToDate(
                companyTraceabilityStatistics
                  .lastSocialEnvironmentalRiskApiRequest.value,
              )}
          </Text>
        </Box>
      </Box>
    </Styles.Container>
  ) : null
}
